import type { PagedResultDto } from "@services/dto/pagedResultDto"
import paymentScheduleService from "@services/paymentSchedule/paymentScheduleService"
import { action, makeAutoObservable, observable } from "mobx"

class PaymentScheduleStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listPaymentSchedule!: any

  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
    this.listPaymentSchedule = []
  }

  @action
  async createOrUpdate(body: any) {
    const result = await paymentScheduleService.createOrUpdate(body)
    if (!body.id) {
      this.detailData = result
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async newDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await paymentScheduleService.active(id, isActive)
  }
  @action
  async bulkActive(id: number[]) {
    await paymentScheduleService.bulkActive(id)
  }
  @action
  async get(id: number) {
    this.isLoading = true
    const result = await paymentScheduleService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await paymentScheduleService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getList() {
    this.isLoading = true
    const result = await paymentScheduleService
      .getList()
      .finally(() => (this.isLoading = false))
    this.listPaymentSchedule = result
  }
}

export default PaymentScheduleStore
